import { render, staticRenderFns } from "./BasePageLearningUnitInfo.vue?vue&type=template&id=38df0671&scoped=true&"
import script from "./BasePageLearningUnitInfo.vue?vue&type=script&lang=js&"
export * from "./BasePageLearningUnitInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df0671",
  null
  
)

export default component.exports